export default __webpack_public_path__ + "static/media/main_course_5.4d822479.png";